module.exports = __webpack_public_path__ + "img/chairs.a2e74f2b.jpg";